/** @format */

import React, { useRef, useCallback, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SearchIcon from '../../../images/img/search.svg';
import {
	SearchTitleWrapper,
	SearchWrapper,
	SearchInputWrapper,
	SearchIconWrapper,
	SearchBorder,
	SearchBackground,
	MDWrapper,
	MDSearchBorder
} from './styles';
import { useFilter } from '../../modules/dashboard';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { useNavbar } from './useNavbar';
import { useHistory } from 'react-router-dom';

export const Search = ({ RWD }) => {
	const history = useHistory();
	const { isMeetupListPage, localizedLang } = useNavbar();
	const { title, boundFetchMeetups, boundSetTitle } = useFilter();
	const [focus, setFocus] = useState(false);
	const wrapperRef = useRef();
	const inputRef = useRef();
	const [t] = useTranslation('translations');

	const handleSearch = useCallback(() => {
		if (isMeetupListPage) {
			boundFetchMeetups();
		} else if (title) {
			history.push(`/${localizedLang}?title=${title}`);
		}
	}, [title, boundFetchMeetups]);

	const handleClickAway = useCallback(() => {
		setFocus(false);
	}, [setFocus]);

	useOnClickOutside(wrapperRef, handleClickAway);

	if (RWD === 'MD' || RWD === 'SM') {
		return (
			<>
				<MDSearchBorder>
					<MDWrapper className="eatme-nav">
						<div className="eatme-nav-item" style={{ marginLeft: '10px' }}>
							<SearchTitleWrapper>
								<Trans i18nKey={'navbar.search_meet'} />
							</SearchTitleWrapper>
						</div>
						<div className="eatme-nav-item" style={{ marginLeft: '10px' }}>
							<SearchInputWrapper ref={inputRef}>
								<input
									type="text"
									placeholder={t('navbar.search_title')}
									style={{ border: 'none' }}
									value={title}
									onChange={(e) => boundSetTitle(e.target.value)}
								/>
							</SearchInputWrapper>
						</div>
						<div className="search eatme-nav-end eatme-nav-item">
							<SearchIconWrapper onClick={handleSearch}>
								<img src={SearchIcon} width="20" height="20" />
							</SearchIconWrapper>
						</div>
					</MDWrapper>
				</MDSearchBorder>
				<div style={{ height: '52px' }}></div>
			</>
		);
	} else {
		return (
			<>
				<SearchBorder
					ref={wrapperRef}
					onClick={() => setFocus(true)}
					focus={focus}>
					<SearchBackground>
						<SearchWrapper>
							<SearchTitleWrapper>
								<Trans i18nKey={'navbar.search_meet'} />
							</SearchTitleWrapper>
							<SearchInputWrapper ref={inputRef}>
								<input
									type="text"
									placeholder={t('navbar.search_title')}
									style={{ width: '144px', border: 'none' }}
									value={title}
									onChange={(e) => boundSetTitle(e.target.value)}
								/>
							</SearchInputWrapper>

							<SearchIconWrapper onClick={handleSearch}>
								<img src={SearchIcon} width="20" height="20" />
							</SearchIconWrapper>
						</SearchWrapper>
					</SearchBackground>
				</SearchBorder>
				<div style={{ height: '52px' }}></div>
			</>
		);
	}
};

export default React.memo(Search);
